<template>
	<main class="home">
		<section v-if="getHome" class="main_banner">
			<MainSwiperSlide v-if="getHome.data.banner_top" :data="getHome.data.banner_top ?? []" />
		</section>
		<article v-if="getHome">
			<ResponsiveLayout class="responsive-layout">
				<MarketTimingLayout>
					<InputSearch
						:model-value="searchValue"
						:is-left="true"
						:class="{ active_search: searchValue.length > 0 }"
						:placeholder="PLACEHOLDER_SEARCH_TITLE"
						@update:model-value="onInputSearch"
						><SearchDropDown
							v-if="searchValue.length !== 0"
							:data="eventSearchData?.search_result ?? []"
							class="search_dropdown"
							@close="onClickSearchList"
					/></InputSearch>
				</MarketTimingLayout>
			</ResponsiveLayout>

			<section class="week_top">
				<h1>주간 상승률</h1>
				<div class="stock_tap">
					<div
						v-for="(item, index) in STOCK_MENU_TAB"
						:key="index"
						:class="{ on: stockTap === `${item.tab}` }"
						@click="onSelectStockTab"
					>
						{{ item.tab }}
					</div>
					<button
						class="btn_tooltip"
						@mousemove="
							deviceStore.getDevice === 'MO' ? (isTooltipOpened = !isTooltipOpened) : (isTooltipOpened = true)
						"
						@mouseout="isTooltipOpened = false"
					>
						<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
						<div v-if="isTooltipOpened" class="box_tooltip">
							<p class="tooltip_title">{{ MARKET_CAP_CRITERIA }}</p>
							<ul class="tooltip_content">
								<li v-for="(item, index) in STOCK_MENU_TAB" :key="index" class="tooltip_content_item">
									<p class="content_title">{{ item.tab }}</p>
									<p v-dompurify-html="item.unit" class="content_description"></p>
								</li>
							</ul>
						</div>
					</button>
				</div>
				<div class="stock_list">
					<div
						v-for="(item, idx) in stockTap === `${SMALL_CAP_STOCK}`
							? getHome?.data.ranking_small
							: stockTap === `${MID_SMALL_CAP_STOCK}`
								? getHome?.data.ranking_mediumsmall
								: getHome?.data.ranking_mediumlarge"
						:key="idx"
						class="stock_item"
					>
						<img :src="item.file_path" alt="대가이미지" loading="lazy" />
						<div>
							<span>{{ item.master_name }}</span
							><b>{{ item.master_rate_competition_stock }}</b
							><b>{{ `+${item.master_rate_competition_ratio}%` }}</b>
						</div>
					</div>
				</div>
			</section>

			<section
				v-if="getHome?.data.banner_middle_top[0]"
				class="banner_sub"
				@click="
					onClickBanner(
						getHome?.data.banner_middle_top[0].banner_url ?? ''
						// getHome?.data.banner_middle_top[0].banner_mo_url ?? ''
					)
				"
			>
				<img
					v-if="getHome?.data.banner_middle_top[0]"
					:src="getHome?.data.banner_middle_top[0].banner_image_url"
					alt="banner_middle_top"
					loading="lazy"
				/>
			</section>

			<ResponsiveLayout>
				<section v-if="hotRankingCategoryList.length > 0" class="hotranking">
					<ExpandableTitleBar title="Hot 랭킹" :position="'left'" :has-view="false" :content="HOT_RANK_TOOLTIP" />
					<HotRankGridList :data="hotRankingCategoryList" />
				</section>
			</ResponsiveLayout>
			<section v-if="getHome?.data.banner_middle_bottom.length" class="best_banner">
				<SubSwiperSlide
					v-if="!isLoading || getHome?.data.banner_middle_bottom"
					:data="getHome?.data.banner_middle_bottom ?? []"
					:thin="true"
				/>
			</section>

			<section class="best_top">
				<h1>Best 상승률 <b>Top10</b></h1>
				<div class="month_tap">
					<div
						v-for="(month, index) in MONTH_MENU_TAB"
						:key="index"
						:class="{ on: tab === `${month}` }"
						@click="onSelectPeriodTab"
					>
						{{ month }}
					</div>
				</div>
				<div class="rank_list">
					<RankList
						v-for="(item, idx) in (tab === `${ONE_MONTH}`
							? getHome?.data.master_best_rise_one ?? []
							: tab === `${THREE_MONTH}`
								? getHome?.data.master_best_rise_thr ?? []
								: getHome?.data.master_best_rise_six ?? []
						).slice(0, moreNumber)"
						:key="idx"
						:data="item"
						:idx="idx + 1"
					/>
					<button
						v-if="moreNumber !== 10"
						class="c_button dark font-semi radius-x-small"
						@click="moreNumber = moreNumber + 5"
					>
						<span>{{ MORE }}</span
						><img src="@/assets/img/common/arrow_down.svg" alt="더보기 아이콘" loading="lazy" />
					</button>
				</div>
			</section>

			<!-- <section v-if="masterBestFiveData?.data.masterpick_ranking_five.length" class="best_top">
				<h1>대가의 관심주 <b>Best5</b></h1>
				<div class="rank_list">
					<MotionList
						v-for="(item, idx) in masterBestFiveData?.data.masterpick_ranking_five"
						:id="idx + 1"
						:key="idx"
						:data="item"
					/>
				</div>
			</section> -->

			<section
				v-if="getHome?.data.banner_bottom[0]"
				class="banner_sub"
				@click="
					onClickBanner(
						getHome?.data.banner_bottom[0].banner_url ?? ''
						// getHome?.data.banner_bottom[0].banner_mo_url ?? ''
					)
				"
			>
				<img
					v-if="getHome?.data.banner_bottom[0]"
					:src="getHome?.data.banner_bottom[0].banner_image_url"
					alt="banner_sub"
					loading="lazy"
				/>
			</section>
			<section v-if="getHome && getHome?.data.youtube.length > 0" class="youtube">
				<div class="youtube_header">
					<h1>YouTube</h1>
					<div class="button_box">
						<button type="button" class="c_button font-semi" @click="onClickYoutubeAll">
							<span>더보기</span>
							<div>
								<img src="@/assets/img/common/arrow_next.svg" alt="유튜브 더보기 아이콘" loading="lazy" />
							</div>
						</button>
					</div>
				</div>
				<YoutubeList v-if="!isLoading" :data="getHome?.data.youtube" />
			</section>
		</article>
	</main>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { debounce } from 'lodash';

import { useGetEventSearchApi } from '@/api/event';
import { useGetHomeApi } from '@/api/home';
import { useGetHotrankingCategoryApi_KR } from '@/api/hotRanking';
import SearchDropDown from '@/components/atom/dropdown/SearchDropDown.vue';
import ExpandableTitleBar from '@/components/atom/tabBar/ExpandableTitleBar.vue';
import HotRankGridList from '@/components/home/HotRankGridList.vue';
import YoutubeList from '@/components/home/YoutubeList.vue';
import MarketTimingLayout from '@/components/layout/main/MarketTimingLayout.vue';
import ResponsiveLayout from '@/components/layout/main/ResponsiveLayout.vue';
// import MotionList from '@/components/rankList/MotionList.vue';
import RankList from '@/components/rankList/RankList.vue';
import MainSwiperSlide from '@/components/swiper/MainSwiperSlide.vue';
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';
import {
	HOT_RANK_TOOLTIP,
	MARKET_CAP_CRITERIA,
	MID_SMALL_CAP_STOCK,
	MONTH_MENU_TAB,
	MORE,
	ONE_MONTH,
	SMALL_CAP_STOCK,
	STOCK_MENU_TAB,
	THREE_MONTH,
} from '@/constants/title';
import { PLACEHOLDER_SEARCH_TITLE } from '@/constants/title';
import { useDeviceStore } from '@/stores/device';
import { openNativeBrowser } from '@/utils/native';
// import { useGetMasterBestFiveApi } from '@/api/home';

const router = useRouter();
// -----variable-----
const deviceStore = useDeviceStore();
const searchValue = ref('');
const tab = ref('1개월');
const stockTap = ref('소형주');
const moreNumber = ref(5);
const isTooltipOpened = ref(false);

// -----api-----
const { data: eventSearchData } = useGetEventSearchApi(
	computed(() => ({ search: searchValue.value })),
	computed(() => !!searchValue.value)
);
const { data: getHome, isLoading } = useGetHomeApi();
const { data: hotrankingCategoryData } = useGetHotrankingCategoryApi_KR(
	computed(() => ({ hot_ranking_category_pk: '' }))
);
// const { data: masterBestFiveData } = useGetMasterBestFiveApi();

// -----computed-----
const hotRankingCategoryList = computed(() => {
	if (!hotrankingCategoryData.value?.hotranking_category) return [];
	return Object.values(hotrankingCategoryData.value.hotranking_category).flat();
});

// -----function-----
// 검색 시 실행 함수
const onInputSearch = debounce(
	(val: string) => {
		searchValue.value = val;
	},
	200,
	{ leading: false }
);

// 검색 초기화 함수
const onClickSearchList = () => {
	searchValue.value = '';
};

// 배너 클릭 시 실행 함수
const onClickBanner = (url: string) => {
	const formatUrl = url.replace('https://www.masterpick.co.kr', '');
	router.push(formatUrl);
	// let agent = navigator.userAgent.toLowerCase();
	// if (agent.indexOf('android') !== -1 && window.masterpick) {
	// 	window.location.href = url;
	// } else if (
	// 	(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
	// 	window.webkit &&
	// 	window.webkit.messageHandlers &&
	// 	window.webkit.messageHandlers.nativeUrlOpenBrowser
	// ) {
	// 	window.webkit.messageHandlers.nativeUrlOpenBrowser.postMessage(moUrl);
	// } else {
	// 	window.open(url, '_self');
	// }
};

// 유튜브 더보기 클릭 시 실행 함수
const onClickYoutubeAll = () => {
	const url = 'https://www.youtube.com/@master_pick/videos';
	let agent = navigator.userAgent.toLowerCase();
	if (agent.indexOf('android') !== -1 && window.masterpick) {
		openNativeBrowser(url);
	} else if (
		(agent.indexOf('iphone') !== -1 || agent.indexOf('ipad') !== -1 || agent.indexOf('macintosh') !== -1) &&
		window.webkit &&
		window.webkit.messageHandlers &&
		window.webkit.messageHandlers.nativeUrlOpenBrowser
	) {
		openNativeBrowser(url);
	} else {
		window.open(url);
	}
};

// 기간 탭 클릭 시 실행 함수
const onSelectPeriodTab = (e: Event) => {
	const target = e.target as HTMLElement;
	const text = target.innerText;
	moreNumber.value = 5;
	tab.value = text;
};

// 주식 탭 클릭 시 실행 함수
const onSelectStockTab = (e: Event) => {
	const target = e.target as HTMLElement;
	const text = target.innerText;
	stockTap.value = text;
};
</script>
<style lang="scss" scoped>
.home {
	background-color: var(--color-bg);
	padding-top: var(--header-height);
	@media screen and (max-width: 1280px) {
		padding-top: var(--mobile-header-height);
	}
	.main_banner {
		:deep(.swiper) {
			height: 100%;
			.swiper-slide > img {
				height: 60rem;
				@media screen and (max-width: 1280px) {
					height: 40rem;
				}
			}
		}
	}
	.responsive-layout {
		position: relative;
		.search_dropdown {
			position: absolute;
			top: 4.8rem;
			background: var(--color-bg);
			z-index: 10;
			border: 1px solid var(--color-primary);
			border-radius: 0rem 0rem 0.8rem 0.8rem;
			overflow: hidden;
		}
	}
	article {
		display: flex;
		flex-direction: column;
		gap: 8.8rem;
		max-width: 68rem;
		margin: 0 auto;
		padding-top: 8.8rem;
		padding-bottom: 8.8rem;
		@media screen and (max-width: 1280px) {
			padding-top: 8rem;
			padding-bottom: 8rem;
			gap: 8rem;
		}
		.banner_sub {
			img {
				cursor: pointer;
				object-fit: fill;
				border-radius: 0.8rem;
				@media screen and (max-width: 1280px) {
					height: 12rem;
				}
			}
			@media screen and (max-width: 1280px) {
				padding-left: var(--space-large);
				padding-right: var(--space-large);
			}
		}
		.search {
			display: flex;
			flex-direction: column;
			gap: var(--space-large);
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-x-large);
			color: var(--color-base-white);
			@media screen and (max-width: 1280px) {
				padding-left: var(--space-large);
				padding-right: var(--space-large);
			}
		}
		.best_banner {
			cursor: pointer;
			@media screen and (max-width: 1280px) {
				padding-left: var(--space-large);
				padding-right: var(--space-large);
			}
		}
		.best_top {
			display: flex;
			flex-direction: column;
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-x-large);
			color: var(--color-base-white);
			gap: var(--space-large);
			line-height: 2.387rem;
			@media screen and (max-width: 1280px) {
				> *:not(.month_tap) {
					padding-left: var(--space-large);
					padding-right: var(--space-large);
				}
			}
			b {
				color: var(--color-danger);
			}
			.month_tap {
				display: flex;
				font-weight: var(--font-w-medium);
				font-size: var(--font-s-regular);
				color: var(--color-base-light);
				div {
					flex: 1;
					text-align: center;
					padding: 1.6rem 0;
					border-bottom: 1px solid var(--color-base-mid-dark);
					cursor: pointer;
				}
				.on {
					border-color: var(--color-primary);
					color: var(--color-primary);
				}
			}
			.rank_list {
				display: flex;
				flex-direction: column;
				gap: 1rem;
				button {
					display: flex;
					gap: 0.25rem;
					height: 5.2rem;
				}
			}
		}
		.week_top {
			display: flex;
			flex-direction: column;
			gap: var(--space-large);
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-x-large);
			line-height: 2.387rem;
			color: var(--color-base-white);
			h1 {
				@media screen and (max-width: 1280px) {
					padding-left: var(--space-large);
					padding-right: var(--space-large);
				}
			}
			.stock_tap {
				display: flex;
				font-weight: var(--font-w-medium);
				font-size: var(--font-s-regular);
				line-height: 2.1rem;
				color: var(--color-base-light);
				div {
					flex: 1;
					text-align: center;
					border-bottom: 1px solid var(--color-base-mid-dark);
					padding: 1.6rem 0;
					cursor: pointer;
				}
				button {
					@media screen and (max-width: 1280px) {
						flex: 0.2;
						padding-right: 2rem;
					}
					border-bottom: 1px solid var(--color-base-mid-dark);
					position: relative;
					img {
						width: 2.4rem;
					}
					.box_tooltip {
						position: absolute;
						display: flex;
						flex-direction: column;
						align-items: start;
						gap: 1rem;
						position: absolute;
						top: 104%;
						right: 0;
						z-index: 10;
						width: 24rem;
						background-color: var(--color-bg-light);
						padding: 1.6rem;
						border-radius: 0.8rem;
						box-shadow: 4px 4px 10px 0px #0000004d;
						color: var(--color-base-white);
						.tooltip_title {
							font-size: var(--font-s-mid);
							font-weight: var(--font-w-medium);
							line-height: 1.79rem;
						}
						.tooltip_content {
							display: flex;
							flex-direction: column;
							gap: 1rem;
							font-size: var(--font-s-mid);
							text-align: start;
							.tooltip_content_item {
								display: flex;
								gap: 1.6rem;
							}
							.content_title {
								width: 7rem;
								font-weight: var(--font-w-light);
								line-height: 1.9rem;
							}
							.content_description {
								font-weight: var(--font-w-medium);
								line-height: 1.79rem;
								:deep(strong) {
									color: var(--color-secondary);
									font-weight: var(--font-w-medium);
								}
							}
						}
					}
				}
				.on {
					border-color: var(--color-primary);
					color: var(--color-primary);
				}
			}
			.stock_list {
				display: flex;
				padding-top: 1.2rem;
				.stock_item {
					flex: 1;
					display: flex;
					flex-direction: column;
					gap: var(--space-x-small);
					align-items: center;
					img {
						object-fit: contain;
						width: 5.8rem;
						height: 5.8rem;
					}
					div {
						display: flex;
						flex-direction: column;
						align-items: center;
						gap: var(--space-xx-small);
						span {
							font-size: var(--font-s-mid);
							font-weight: var(--font-w-light);
							line-height: 1.9rem;
						}
						b:nth-child(2) {
							font-size: var(--font-s-regular);
							font-weight: var(--font-w-medium);
							color: #fff;
							line-height: 2.1rem;
						}
						b:nth-child(3) {
							font-size: var(--font-s-regular);
							font-weight: var(--font-w-medium);
							color: var(--color-danger);
							line-height: 2.1rem;
						}
					}
				}
			}
		}
		.hotranking {
			display: flex;
			flex-direction: column;
			gap: var(--space-large);
		}
		.youtube {
			display: flex;
			flex-direction: column;
			gap: var(--space-large);
			font-weight: var(--font-w-semi-bold);
			font-size: var(--font-s-x-large);
			line-height: 2.387rem;
			color: var(--color-base-white);
			.youtube_header {
				display: flex;
				justify-content: space-between;
				@media screen and (max-width: 1280px) {
					padding-left: var(--space-large);
					padding-right: var(--space-large);
				}
				.c_button {
					padding: 0rem;
					font-weight: var(--font-w-medium);
					font-size: var(--font-s-mid);
					line-height: 1.79rem;
					height: unset;
					img {
						width: 1.8rem;
					}
				}
			}
		}
	}
}
</style>
